// `splayParams` helps destructure params objects such as
// `$uiRouterGlobals.params` and decorates them with common values such as the api
// key, before using them in queries.
//
// Parameter names listed in attrs are removed from the params
// hash and their associated values are passed back in the return
// array, positionally-matched to their names in the `attrs` array.
export function splayParams(originalParams?: any, ...attrs: any[]) {
  // Preserve original parameters object,
  // Especially important where $uiRouterGlobals.params is passed in,
  // as modification of $uiRouterGlobals.params directly influences
  // ui state.
  const params = { ...originalParams };

  const extracted = (() => {
    const result = [];
    for (const attr of attrs) {
      const val = params[attr];
      delete params[attr];
      result.push(val);
    }
    return result;
  })();

  // Return params and positional splayParams
  return [params].concat(extracted);
}
